// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;
SelectOption.displayName = 'S.SelectOption';

export const SelectOptionLabel = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 80px;
`;
SelectOptionLabel.displayName = 'S.SelectOptionLabel';

export const SelectOptionPill = styled.div`
  position: absolute;
  right: 16px;
`;
SelectOptionPill.displayName = 'S.SelectOptionPill';
